'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
const EMOTION_STYLE_SELECTOR = 'style[data-emotion="css"][data-s=""]';
const EMOTION_CHECK_DELAY_MS = 100;
const CheckEmotionTagExist = () => {
  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      const emotionTag = document.querySelector(EMOTION_STYLE_SELECTOR);
      if (!emotionTag) {
        Sentry.captureException(new Error('Emotion SSR style tag missing: <style data-emotion="css" data-s=""></style>'), {
          tags: {
            section: 'emotion',
            issue: 'missing_emotion_style_tag'
          },
          level: 'error'
        });
      }
    }, EMOTION_CHECK_DELAY_MS);
    return () => window.clearTimeout(timeoutId);
  }, []);
  return null;
};
export default CheckEmotionTagExist;